import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Card, Spinner } from 'react-bootstrap';
import styles from '../../../styles.module.css';
import { getPrefix } from '../../../util/utils';
import history from '../../../services/history';
import useTrans from '../../../hooks/useTrans';
import IcmHeaderImage from '../../../components/IcmHeaderImage';
import LaudoCardHeader from '../../../components/laudos/LaudoCardHeader';
import generateTransPDF from './generateTransPDF';

export default function ReportTrans() {
  const { id } = useParams();
  const { data, error, isLoading } = useTrans(id);
  const [trans, setTrans] = useState(null);

  useEffect(() => {
    if (data)
      setTrans(data[0]);
  }, [data]);

  const handleGoBack = () => history.goBack();

  const handleRemoveDiv = () => {
    generateTransPDF(trans, 'imprimirTimbrado');
    window.scrollTo(0, 0);
    // window.print();
  };

  if (isLoading || error || !trans) {
    return (
      <Card className="mt-2">
        <div
          className={`${styles.imageReport} timbradoHeaderPrint`}
          style={{ marginTop: 0 }}
        >
          <IcmHeaderImage variant="print" />
        </div>
        <LaudoCardHeader title="ECOCARDIOGRAMA TRANSESOFÁGICO" />
        {isLoading && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: '80vh' }}
          >
            <Spinner animation="border" variant="dark" size="lg" />
          </div>
        )}
        {!isLoading && (
          <>
            <span className="text-danger text-center d-block mt-2">
              {error
                ? 'Erro ao carregar laudo de trans! Tente novamente.'
                : 'Laudo não encontrado.'}
            </span>
            <Card.Footer className="text-muted text-center">
              <Button
                variant="warning"
                onClick={handleGoBack}
                aria-label="Voltar"
              >
                Voltar
              </Button>
            </Card.Footer>
          </>
        )}
      </Card>
    );
  }

  return (
    <Card className="mt-2 mb-2">
       <div
          className={`${styles.imageReport} timbradoHeaderPrint`}
          style={{ marginTop: 0 }}
        >
          <IcmHeaderImage variant="print" />
        </div>
      <LaudoCardHeader title="ECOCARDIOGRAMA TRANSESOFÁGICO" />
      <Card.Body>
        <strong className="mr-auto">Nome do Paciente: </strong>
        {`${trans.CODPAC} - ${trans.NOMEPAC}`}
        <br />
        <strong className="mr-auto">Data de Nasc: </strong>
        {`${trans.dataNasc}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong className="mr-auto">Sexo: </strong>
        {`${trans.SEXOPAC}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong className="mr-auto">Idade: </strong>
        {`${trans.idadePAC} anos`}
        <br />
        <strong className="mr-auto">Convênio: </strong>
        {trans.SIGLACONV}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong className="mr-auto">Código: </strong>
        {trans.CODSTRESS}&nbsp;&nbsp;&nbsp;
        <strong className="mr-auto">Data do Stress: </strong>
        {trans.dataTrans}
        <br />
        <strong className="mr-auto">
          Médico que Solicitou: {getPrefix(trans.CODSOLICITANTE)}{' '}
        </strong>
        {`${trans.Solicitou}`}
        <hr />
        <div id="isquemia" className="mb-2" style={{ fontSize: 17 }}>
          <div className={styles.preContent}>{trans.ECOTRANS}</div>
        </div>
        <Card className="text-center">
          <Card.Body>
            <div className={styles.signatureReport}>
              <i className="mr-auto">
                Conferido e assinado eletronicamente por:{' '}
                <strong className="mr-auto">
                  {getPrefix(trans.CODREALIZOU)} {trans.Realizou}
                </strong>
              </i>
              <br />
              <i>Assinatura Digital: {trans.HASH}</i>
            </div>
          </Card.Body>
        </Card>
      </Card.Body>
      <Card.Footer className="text-muted text-center">
        <Button
          onClick={handleRemoveDiv}
          aria-label="Imprimir laudo"
        >
          Imprimir
        </Button>{' '}
        <Button variant="warning" onClick={handleGoBack} aria-label="Voltar">
          Voltar
        </Button>
      </Card.Footer>
    </Card>
  );
}
